import { LynxService } from "../../services/lynx.service";
import { Proto } from "../../pojo/Proto";
import NumericalBoolean = Proto.NumericalBoolean;
import ISODateString = Proto.ISODateString;
import { StateService } from "../../services/state.service";

export class LynxPrefsService {
    disabledServices: LynxPrefs.Data[] = [];
    services: LynxPrefs.Data[] = [];

    public static getCurrentLynxInst() {
        console.log("state", StateService.current());
    }

    public static async getPreferences(prefs: string[]): Promise<LynxPrefs.Data[]> {
        const instance = "qawd"; //TODO dynamically get instance

        LynxPrefsService.getCurrentLynxInst();

        const data = await LynxService.callLynxInstance<Promise<{ pref: { object: LynxPrefs.Data[] } }>>(
            instance,
            "get",
            `pref.json?cmd=values&pref_names=${prefs.join("+")}`,
        );

        return data?.pref?.object ?? [];
    }

    public static isPrefDisabled(pref: LynxPrefs.Data) {
        return pref.prevValueId !== 1;
    }
}

export namespace LynxPrefs {
    export type PrefNames =
        | "sys_integration_type"
        | "sys_sis"
        | "sys_sis_subtype"
        | "sys_sis_dbms"
        | "sys_timezone"
        | "sys_timezone_sis"
        | "sys_version"
        | "sys_exam_enabled"
        | "sys_exam_sis_enabled"
        | "sys_exam_saas_enabled"
        | "sys_client_patch_enabled"
        | "init_enabled"
        | "init_reg_enabled"
        | "imp_enabled"
        | "hist_sis_enabled"
        | "hist_r25_enabled"
        | "exp_enabled"
        | "api_dispatcher_enabled"
        | "imp_loc_enabled"
        | "imp_org_enabled"
        | "api_instance"
        | "sys_eval_enabled";

    export type Data = {
        prefNote: string;
        prefValueText: string; //{ nil: boolean };
        prefValueId: number; //TODO find what reasonable values are
        prefNameDisp: string;
        isEditable: NumericalBoolean;
        pos: number;
        prefDesc: string;
        prevValueId: number;
        prefTypeId: number;
        prefName: PrefNames;
        lastModDt: ISODateString;
        prefValueDesc: string;
    };
}
